import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import SearchIndex from "shared/lib/search_index"
import IFTTTNextSearchInput from "app/components/ifttt_next/shared/search_input"

// SearchInput is the only component that we can't move to pure function because of `searchTerm` state.
// When we use useState, it re-render component every change as opposed to this.state.
export default class SearchInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
    }
    this.allServices = props.services.map(s => s.id)

    this.index = new SearchIndex()
    props.services.forEach(doc => {
      this.index.add(doc.id, doc.name)
    })
  }

  componentDidMount() {
    // Only autofocus on desktop
    let width = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    )
    if (width >= 768) {
      this.inputRef.focus()
    }
  }

  onChange = evt => {
    if (!evt.target.value) {
      return this.clearSearch()
    }

    this.setState({ searchTerm: evt.target.value }, () => {
      this.props.onSearch(this.index.search(this.state.searchTerm.trim()))
    })
  }

  clearSearch = () => {
    this.setState({ searchTerm: "" })
    this.props.onSearch(this.allServices)
  }

  render() {
    const classes = classnames("ifttt-next-search", {
      search: this.state.searchTerm !== "",
    })

    return (
      <div className={classes}>
        <IFTTTNextSearchInput
          autoFocus={false}
          onChange={this.onChange}
          onXClick={this.clearSearch}
          placeholder="Search services"
          value={this.state.searchTerm}
          ref={ref => (this.inputRef = ref)}
        />
      </div>
    )
  }
}

SearchInput.propTypes = {
  services: PropTypes.array.isRequired,
  onSearch: PropTypes.func.isRequired,
}
